<template>
	<v-dialog v-model="dialog" persistent max-width="650" scrollable>
		<v-card class="bg-light-primary">
			<v-card-title class="justify-space-between">
				<div class="font-size-14 cl-secondary">Detail Omset Group</div>
				<v-btn small text class="px-0 mr-n4" @click="modalHide">
					<v-icon color="red">mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text>
				<v-col class="pa-0 border-top border-grey">
					<div class="pt-2">
						<v-row>
							<v-col cols="12" class="pt-0">
								<v-simple-table class="white-row table-vo table-history-transfer">
									<template v-slot:default>
										<thead class="">
											<tr>
												<th class="text-left">Tanggal</th>
												<th class="text-left">Kode Jalur Mitra</th>
												<th class="text-left">Kode Mitra</th>
												<th class="text-center">Level</th>
											</tr>
										</thead>
										<tbody class="grey--text text--darken-3">
											<tr v-for="sales in detailGroupOmset" :key="sales.sales_group_id">
												<td class="text-left">
													<div class="d-flex flex-wrap">
														<div class="font-size-20 font-weight-500 primary--text">{{ sales.sales_group_date | toTanggal }}</div>
														<div class="pl-2 font-size-10 my-auto">
															<div>{{ sales.sales_group_date | bulan }}</div>
															<div>{{ sales.sales_group_date | tahun }}</div>
														</div>
													</div>
												</td>
												<td class="text-left">{{ sales.sales_group_line_network_code }}</td>
												<td class="text-left">{{ sales.sales_group_trigger_network_code }}</td>
												<td class="text-center">{{ sales.sales_group_level_real }}</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-col>
						</v-row>
						<div>
							<v-row>
								<v-col cols="12" sm="12" md="12" class="pl-0 pr-0 pb-1 pr-sm-3 pb-sm-3 d-flex justify-sm-start justify-end">
									<v-pagination v-model="page" total-visible="5" class="d-flex justify-end vo-pagination no-button-focus" color="primary" :length="detailGroupOmsetPagination.total_page" ></v-pagination>
								</v-col>
							</v-row>
						</div>
					</div>
				</v-col>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			dialog: false,
			page: 1,
			limit: '10',
		}
	},
	computed:{
		...mapState('repeatOrder', ['detailGroupOmset', 'detailGroupOmsetPagination']),
	},
	props: {
		
	},
	methods :{
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		
	}
};
</script>